import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: CampaignUpdateInput!
  ) {
    updateOneCampaign(
      where: { id: $id }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Campanha actualizada`, mutationTypes.UPDATE)
)

